module.exports = __webpack_public_path__ + "img/rocket-no-flame.ad159ece.svg";